import config from '../config'

function enumize (enumDefinition) {
  const byId = {}

  const list = []

  let key

  let temp

  for (key in enumDefinition) {
    if (enumDefinition.hasOwnProperty(key)) {
      temp = Object.assign({}, enumDefinition[key])
      delete temp.id
      temp[key] = key
      list.push({
        label: enumDefinition[key].label,
        value: enumDefinition[key].id,
        key: enumDefinition[key].value,
        intlKey: enumDefinition[key].intlKey
      })
      byId[enumDefinition[key].id] = temp
    }
  }
  enumDefinition.ids = byId
  enumDefinition.list = list
  return enumDefinition
}

export const ROLES = enumize({
  ALL: { id: 0, u: 'all' },
  PARTICIPANT: { id: 1, u: 'participant', role: 'PARTICIPANT' },
  LEADER: { id: 2, u: 'leader', role: 'AWARD_LEADER' },
  NAO_STAFF: { id: 3, u: 'naa_oa_staff', role: 'NAA_OA_STAFF' },
  GOP_STAFF: { id: 4, u: 'gop_staff', role: 'GOP_STAFF' },
  IF_STAFF_SUPER: {
    id: 5,
    u: 'if_staff_superuser',
    roles: 'IF_STAFF_SUPERUSER',
    organizationId: 1,
    apiUserType: 'if_staff_superuser'
  },
  IF_STAFF_USER: { id: 6, u: 'if_staff_stat_user', role: 'IF_STAFF_STAT_USER' },
  IF_STAFF_STATISTICAL_USER: { id: 7, u: 'if_staff_superuser', role: 'IF_STAFF_STATISTICAL_USER' },
  IF_STAFF_VIEWER: { id: 8, u: 'if_staff_viewer', role: 'IF_STAFF_VIEWER' },
  AWARD_VERIFIER: { id: 9, u: 'award_verifier', role: 'AWARD_VERIFIER' },
  COORDINATOR: { id: 10, u: 'coordinator', role: 'COORDINATOR' },
  AJ_ASSESSOR: { id: 11, u: 'aj_assessor', role: 'AJ_ASSESSOR' },
  ASSESSOR: { id: 12, u: 'assessor', role: 'ASSESSOR' },
  AJ_SUPERVISOR: { id: 13, u: 'aj_supervisor', role: 'AJ_SUPERVISOR' },
  AJ_INSTRUCTOR: { id: 14, u: 'aj_instructor', role: 'AJ_INSTRUCTOR' },
  GBT: {
    id: 15,
    u: 'gtb_staff_superuser',
    role: 'GBT',
    organizationId: 2,
    hierarchyType: 'RO',
    apiUserType: 'if_staff_superuser'
  },
  OA: { id: 16, u: 'oa_staff', role: 'OA', hierarchyType: 'OA', apiUserType: 'naa_oa_staff' },
  SOA: { id: 17, u: 'soa_staff', role: 'SOA', hierarchyType: 'SOA', apiUserType: 'naa_oa_staff' },
  IF_REGION: { id: 18, u: 'if_region', role: 'IF_REGION', apiUserType: 'if_staff_superuser' }
})

/* eslint-disable */
export const USER_TYPES = enumize({
  [ROLES.PARTICIPANT.u]: {
    defaultRedirect: `${config.publicPath}/participants`
  },
  [ROLES.LEADER.u]: {
    defaultRedirect: `${config.publicPath}/tasks/registration-participants`
  },
  [ROLES.NAO_STAFF.u]: {
    defaultRedirect: `${config.publicPath}/registrations`
  },
  [ROLES.IF_STAFF_SUPER.u]: {
    defaultRedirect: `${config.publicPath}/participants`
  },
  [ROLES.IF_STAFF_USER.u]: {
    defaultRedirect: `${config.publicPath}/reports`
  },
  [ROLES.IF_STAFF_VIEWER.u]: {
    defaultRedirect: `${config.publicPath}/participants`
  },
  [ROLES.AWARD_VERIFIER.u]: {
    defaultRedirect: `${config.publicPath}/awards/local-office-signoffs`
  },
  [ROLES.COORDINATOR.u]: {
    defaultRedirect: `${config.publicPath}/participants`
  },
  [ROLES.AJ_ASSESSOR.u]: {
    defaultRedirect: `${config.publicPath}/participants`
  },
  [ROLES.ASSESSOR.u]: {
    defaultRedirect: `${config.publicPath}/participants`
  },
  [ROLES.GBT.u]: {
    defaultRedirect: `${config.publicPath}/registrations`
  },
  [ROLES.OA.u]: {
    defaultRedirect: `${config.publicPath}/registrations`
  },
  [ROLES.SOA.u]: {
    defaultRedirect: `${config.publicPath}/registrations`
  },
  [ROLES.IF_REGION.u]: {
    defaultRedirect: `${config.publicPath}/participants`
  }
})
/* eslint-disable */

export const PAYMENTS = enumize({
  NOT_PAID: { id: 'NOT_PAID' },
  ONLINE_MASTERCARD: { id: 'ONLINE_MASTERCARD' },
  PAYPAL: { id: 'ONLINE_PAYPAL' },
  GPE: { id: 'ONLINE_GP' },
  GPWP: { id: 'ONLINE_GP_WP' }
})


export const AWARD_PAYMENT_STATES = enumize({
  PAID: { id: 'PAID' },
  NOT_PAID: { id: 'NOT_PAID' },
  EXEMPT: { id: 'EXEMPT' },
  WAITING: { id: 'WAITING' },
  LATER: { id: 'LATER' }
})

export const TASKS_OVERVIEW = enumize({
  AWARD_REGISTRATION: { id: 'registration' },
  AL_REGISTRATION: { id: 'al_registration' },
  ASSESSOR_REGISTRATION: { id: 'as_registration' },
  ASSESSOR_ACTIVITY_REGISTRATION: { id: 'as_cat_reg_registration' },
  ASSESSOR_WWC_UPDATE: { id: 'as_wwc_update' },
  AU_REGISTRATION: { id: 'au_registration' },
  SECTION_APPROVAL: { id: 'section_approval' },
  SECTION_SIGNOFF: { id: 'section_signoff' },
  AJ_SIGNOFF: { id: 'adventurous_journey' },
  AWARD_SIGNOFF: { id: 'award_signoff' },
  AWARD_OFFICE_SIGNOFF: { id: 'award_office_signoff' },
  PAYMENTS: { id: 'payments' },
  AWARD_OFFICE_SIGNOFF_LOCALLY: { id: 'award_office_signoff_locally' },
  UNASSIGNED_PARTICIPANTS: { id: 'unassigned_participants' },
  INVITED_PARTICIPANTS: { id: 'invited_participants' },
  EMAIL_REVISION: { id: 'email_revision' }
})

export const LEVELS = enumize({
  BRONZE: {
    id: 1,
    label: 'Bronze',
    value: 'BRONZE',
    intlKey: 'award.bronze_level_short',
    filter: 'participantsBronzeAwards'
  },
  SILVER: {
    id: 2,
    label: 'Silver',
    value: 'SILVER',
    intlKey: 'award.silver_level_short',
    filter: 'participantsSilverAwards'
  },
  GOLD: {
    id: 3,
    label: 'Gold',
    value: 'GOLD',
    intlKey: 'award.gold_level_short',
    filter: 'participantsGoldAwards'
  }
})

export const AJ_TYPES = enumize({
  EXPLORATION: { id: 3 },
  EXPEDITION: { id: 2 },
  ADVENTUROUS_PROJECT: { id: 1 },
  VIRTUAL_BRONZE_EXPEDITION: { id: 1000000 },
  VIRTUAL_SILVER_EXPEDITION: { id: 1000001 },
  VIRTUAL: { id: 2000000 },
  PRACTICAL: { id: 2000001 }
})

export const AJ_EVENT_TYPES = enumize({
  preparation: { id: 'PREPARATION' },
  practice: { id: 'PRACTICE' },
  qualification: { id: 'QUALIFICATION' }
})

export const IMAGE_SIZES = enumize({
  default: { size: 'r=500x500' },
  dropdown: { size: 'r=30x30' }
})

export const COMBO_BOX_LISTS = enumize({
  messageTypeList: [{ label: 'Message', value: 'false' }, { label: 'Comment', value: 'true' }]
})

export const MESSAGE_LISTS = enumize({
  messageStatusList: [{ label: 'Read', value: 'true' }, { label: 'Unread', value: 'false' }]
})

export const CONFIGURATION_KEYS = enumize({
  manageAllParticipants: { id: 'AL_PAR_BY_AU' },
  confirmationEmailBody: {
    id: 'PREG_CONF_EMAIL'
  },
  userGuideParticipant: {
    id: 'U_GUIDE_PART'
  },
  userGuideLeader: {
    id: 'U_GUIDE_AL'
  },
  userGuideWebLeader: {
    id: 'UWEB_GUIDE_AL'
  },
  userGuideWebNao: {
    id: 'UWEB_GUIDE_NAO'
  },
  userGuideWebParticipant: {
    id: 'UWEB_GUIDE_PART'
  },
  parentalConsent: {
    id: 'PAR_CONSENT'
  },
  isParentalConsentRequirementsEnabled: {
    id: 'ENABLE_PC_REQ'
  },
  isParentalConsentRequirementsEnabled2: {
    id: 'ENABLE_PC_REQ2'
  },
  parentalConsentRequirementsTitle: {
    id: 'PAR_CONSENT_REQ_T'
  },
  parentalConsentRequirements: {
    id: 'PAR_CONSENT_REQ'
  },
  parentalConsentRequirementsTitle2: {
    id: 'PAR_CONSENT_REQ2_T'
  },
  parentalConsentRequirements2: {
    id: 'PAR_CONSENT_REQ2'
  },
  termsAndConditions: {
    id: 'T_CONDITIONS'
  },
  termsAndConditionsLeader: {
    id: 'T_CONDITIONS_AL'
  },
  termsAndConditionsUnit: {
    id: 'T_CONDITIONS_AU'
  },
  faqDocuments: {
    id: 'FAQ_DOCUMENTS'
  },
  auCanSignBronze: {
    id: 'AU_SIGN_B_AWARD'
  },
  auCanSignSilver: {
    id: 'AU_SIGN_S_AWARD'
  },
  auCanSignGold: {
    id: 'AU_SIGN_G_AWARD'
  },
  signAwardLocally: {
    id: 'SIGN_AW_LOC',
    valueType: 'BOOLEAN'
  },
  allowRegApproval: {
    id: 'ALLOW_APVL_PREG',
    valueType: 'BOOLEAN'
  },
  directNaoBronze: {
    id: 'DE_NAO_B',
    valueType: 'DECIMAL'
  },
  directNaoSilver: {
    id: 'DE_NAO_S',
    valueType: 'DECIMAL'
  },
  directNaoGold: {
    id: 'DE_NAO_G',
    valueType: 'DECIMAL'
  },
  directOaBronze: {
    id: 'DE_OA_B',
    valueType: 'DECIMAL'
  },
  directOaSilver: {
    id: 'DE_OA_S',
    valueType: 'DECIMAL'
  },
  directOaGold: {
    id: 'DE_OA_G',
    valueType: 'DECIMAL'
  },
  continuationNaoBronze: {
    id: 'CE_NAO_B',
    valueType: 'DECIMAL'
  },
  continuationNaoSilver: {
    id: 'CE_NAO_S',
    valueType: 'DECIMAL'
  },
  continuationNaoGold: {
    id: 'CE_NAO_G',
    valueType: 'DECIMAL'
  },
  continuationOaBronze: {
    id: 'CE_OA_B',
    valueType: 'DECIMAL'
  },
  continuationOaSilver: {
    id: 'CE_OA_S',
    valueType: 'DECIMAL'
  },
  continuationOaGold: {
    id: 'CE_OA_G',
    valueType: 'DECIMAL'
  },
  continuationOaBronzeToGold: {
    id: 'CE_OA_BG',
    valueType: 'DECIMAL'
  },
  continuationNaoBronzeToGold: {
    id: 'CE_NAO_BG',
    valueType: 'DECIMAL'
  },
  paymentLinkThreshold: {
    id: 'PAY_LINK_EXP_TR',
    valueType: 'INTEGER'
  },
  onlineMasterCardPayment: {
    id: 'PREG_ONLMC_PAY',
    valueType: 'BOOLEAN'
  },
  onlinePayPalPayment: {
    id: 'PREG_PAYPAL_PAY',
    valueType: 'BOOLEAN'
  },
  onlineManualPayment: {
    id: 'PREG_ONLMAN_PAY',
    valueType: 'BOOLEAN'
  },
  notRequiredPayment: {
    id: 'PREG_EXEMNT_PAY',
    valueType: 'BOOLEAN'
  },
  directPayment: {
    id: 'PREG_DIRECT_PAY',
    valueType: 'BOOLEAN'
  },
  directTransferPayment: {
    id: 'PREG_D_TRF_PAY',
    valueType: 'BOOLEAN'
  },
  gpWebPayPayment: {
    id: 'PREG_OGPWP_PAY',
    valueType: 'BOOLEAN'
  },
  manualImageTransactionPayment: {
    id: 'PREG_IMG_MAN_PAY',
    valueType: 'BLOB'
  },
  orgCurrency: {
    id: 'ORG_CURRENCY',
    valueType: 'CODE_LIST_VALUE_TRANSLATED'
  },
  boWebLogout: {
    id: 'BO_WEB_LOGOUT_T'
  },
  emailFooter: {
    id: 'EMAIL_FOOTER'
  },
  emailPrefix: {
    id: 'EMAIL_PREFIX'
  },
  manageAssessors: {
    id: 'MANAG_ASSESSOR'
  },
  manageEmails: {
    id: 'ALLOW_EMAIL_MNG'
  },
  assessorConduct: {
    id: 'ASS_CO_CONDUCT'
  },
  assessorRole: {
    id: 'ASS_ROLE'
  },
  assessorKeyConditionRequirements: {
    id: 'ASS_KEY_CON_REQ'
  },
  assessorReferenceHandbook: {
    id: 'ASS_REF_AW_BOOK'
  },
  assessorReferenceOnline: {
    id: 'ASS_REF_ONL_MOD'
  },
  aboutAwardUrl: {
    id: 'ABOUT_AWARD_URL'
  },
  offlineAu: {
    id: 'OFFLINE_AU'
  },
  signOffCoord: {
    id: 'SIGN_OFF_COORD'
  },
  enableAutoMoveAssessedActivity: {
    id: 'ENABLE_AMAA',
    valueType: 'BOOLEAN'
  },
  enableLabels: {
    id: 'ENABLE_LABELS',
    valueType: 'BOOLEAN'
  },
  enableContactLabels: {
    id: 'ENABLE_CONTACT_LABELS',
    valueType: 'BOOLEAN'
  },
  enableOrganizationLabels: {
    id: 'ENABLE_ORG_LABELS',
    valueType: 'BOOLEAN'
  },
  enableAwardLabels: {
    id: 'ENABLE_AWARD_LABELS',
    valueType: 'BOOLEAN'
  },
  enableEditActivity: {
    id: 'ENABLE_EDIT_APPROVED_ACT',
    valueType: 'BOOLEAN'
  },
  enableLogRestriction: {
    id: 'ENABLE_LOG_RESTRICTION',
    valueType: 'BOOLEAN'
  },
  isGOPEnabled: {
    id: 'ENABLE_GOP',
    valueType: 'BOOLEAN'
  },
  isAssessorReportAdditionalInfoEnabled: {
    id: 'ENABLE_ASS_EXTENSION',
    valueType: 'BOOLEAN'
  },
  isPersonalReflectionFroActivityEnabled: {
    id: 'ENABLE_PER_REF_ACT',
    valueType: 'BOOLEAN'
  },
  isAssessorDetailMandatory: {
    id: 'ENABLE_ASS_MD',
    valueType: 'BOOLEAN'
  },
  isMessagingEnabled: {
    id: 'ENABLE_MSG',
    valueType: 'BOOLEAN'
  },
  isShowAwardLeaderDetailsAllowed: {
    id: 'ALLOW_AL_SEE_DETAIL',
    valueType: 'BOOLEAN'
  },
  isChangeCompleteToCeremonyForAwardLeadersAllowed: {
    id: 'ALLOW_AL_CHNG_TO_CEREMONY',
    valueType: 'BOOLEAN'
  },
  isBadgesEnabled: {
    id: 'ENABLE_BADGES',
    valueType: 'BOOLEAN'
  },
  isBadgesStrictModeEnabled: {
    id: 'ENABLE_STRICT_BADGES',
    valueType: 'BOOLEAN'
  },
  isBulkLogsEnabled: {
    id: 'ENABLE_LOGS_BULK',
    valueType: 'BOOLEAN'
  },
  isBulkLogsForBronzeEnabled: {
    id: 'ENABLE_LOGS_BULK_BRONZE',
    valueType: 'BOOLEAN'
  },
  isBulkLogsForSilverEnabled: {
    id: 'ENABLE_LOGS_BULK_SILVER',
    valueType: 'BOOLEAN'
  },
  isBulkLogsForGoldEnabled: {
    id: 'ENABLE_LOGS_BULK_GOLD',
    valueType: 'BOOLEAN'
  },
  allowDeletePaid: {
    id: 'ALLOW_DEL_PAID',
    valueType: 'BOOLEAN'
  },
  allowSelfSign: {
    id: 'ALLOW_SELF_SIGN'
  },
  allowGetProfileQuestionAnswers: {
    id: 'ALLOW_AL_PQA'
  },
  surveyUrl: {
    id: 'SURVEY_URL'
  },
  parentalConsentSurveyDoc: {
    id: 'PAR_CON_DOC'
  },
  postSurveyUrl: {
    id: 'POST_SURVEY_URL'
  },
  enableAssessorWelcomeEmail: {
    id: 'ENABLE_ASS_WM',
    valueType: 'BOOLEAN'
  },
  enableEditPaymentNote: {
    id: 'ENABLE_PN_EDIT',
    valueType: 'BOOLEAN'
  },
  participantRegistrationParentalConsentElectronically: {
    id: 'PREG_PAR_CO_EL',
    valueType: 'BOOLEAN'
  },
  participantRegistrationParentalConsentNotRequired: {
    id: 'PREG_PAR_CO_NR',
    valueType: 'BOOLEAN'
  },
  participantRegistrationParentalConsentPaper: {
    id: 'PREG_PAR_CO_P',
    valueType: 'BOOLEAN'
  },
  postalAddress: {
    id: 'POST_ADDR'
  },
  dbReplicationTime: {
    id: 'DB_REPL_TIME'
  },
  profileQuestionDescription: {
    id: 'PART_REG_PQ_DESC'
  },
  privacyPolicyText: {
    id: 'PREG_PRIV_POL_T'
  },
  AwardLeaderRegistrationPrivacyPolicyUrl: {
    id: 'PP_URL'
  },
  volunteerCodeOfConduct: {
    id: 'VOL_CO_CONDUCT'
  },
  auCoConduct: {
    id: 'AU_CO_CONDUCT'
  },
  auCoConductDoc: {
    id: 'AU_CO_CON_DOC'
  },
  naoRegRequirementsUrl: {
    id: 'NAO_REGQ_URL'
  },
  termsAndConditionsAssessor: {
    id: 'T_CONDITIONS_AS'
  },
  passwordSpecChars: {
    id: 'PSW_SPEC_CHARS'
  },

  participantRegistrationEmailAddress2: {
    id: 'P_REG_AD2'
  },
  participantRegistrationPhoneType: {
    id: 'P_REG_PH_T'
  },
  participantRegistrationSecondaryPhone: {
    id: 'P_REG_SEC_P'
  },
  participantRegistrationSecondaryPhoneType: {
    id: 'P_REG_S_PH_T'
  },
  participantRegistrationTitle: {
    id: 'P_REG_TITLE'
  },
  participantRegistrationMiddleName: {
    id: 'P_REG_M_NAME'
  },
  participantRegistrationNationality: {
    id: 'P_REG_NAT'
  },
  participantRegistrationEmploymentStatus: {
    id: 'P_REG_E_STAT'
  },
  participantRegistrationAddressLine1: {
    id: 'P_REG_ADD1'
  },
  participantRegistrationAddressLine2: {
    id: 'P_REG_ADD2'
  },
  participantRegistrationPhone: {
    id: 'P_REG_PH'
  },
  participantRegistrationAddressCity: {
    id: 'P_REG_CITY'
  },
  participantRegistrationAddressZipCode: {
    id: 'P_REG_PCODE'
  },
  participantRegistrationAddressRegion: {
    id: 'P_REG_REGION'
  },
  participantRegistrationAddressCountry: {
    id: 'P_REG_COUNTRY'
  },
  awardStaffRegistrationEmailAddress2: {
    id: 'OC_REG_AD2'
  },
  awardStaffRegistrationPhone: {
    id: 'OC_REG_PH'
  },
  awardStaffRegistrationTitle: {
    id: 'OC_REG_TITLE'
  },
  awardStaffContactDateOfBirth: {
    id: 'ENABLE_SHOW_DOB'
  },
  awardStaffRegistrationMiddleName: {
    id: 'OC_REG_M_NAME'
  },
  awardStaffRegistrationAddressLine2: {
    id: 'OC_REG_ADD2'
  },
  awardStaffRegistrationAddressLine1: {
    id: 'OC_REG_ADD1'
  },
  awardStaffRegistrationAddressCity: {
    id: 'OC_REG_CITY'
  },
  awardStaffRegistrationAddressZipCode: {
    id: 'OC_REG_PCODE'
  },
  awardStaffRegistrationAddressRegion: {
    id: 'OC_REG_REGION'
  },
  awardStaffRegistrationAddressCountry: {
    id: 'OC_REG_COUNTRY'
  },
  awardStaffRegistrationRole: {
    id: 'OC_REG_ROLE'
  },
  awardStaffRegistrationGender: {
    id: 'OC_REG_GENDER'
  },
  awardLeaderTrainings: {
    id: 'AL_TRAININGS'
  },
  participantRegSkipPayment: {
    id: 'PREG_SKIP_PAY'
  },
  offlineParticipantsImportTemplate: {
    id: 'OFFLINE_PAR_IMPORT_TEMPLATE'
  },
  invitedParticipantsImportTemplate: {
    id: 'INVITED_PAR_IMPORT_TEMPLATE'
  },
  allowSimplifiedBronze: {
    id: 'ALLOW_SIMPLIFIED_BRONZE'
  }

})

export const CONFIGURATION_TYPES = enumize({
  boolean: {
    id: 'BOOLEAN'
  },
  integer: {
    id: 'INTEGER'
  },
  text: {
    id: 'TEXT'
  },
  textTranslated: {
    id: 'TEXT_TRANSLATED'
  },
  decimal: {
    id: 'DECIMAL'
  },
  blob: {
    id: 'BLOB'
  },
  codeListValueTranslated: {
    id: 'CODE_LIST_VALUE_TRANSLATED'
  }
})

export const PAYMENT_TYPES = enumize({
  onlineManual: { id: 'ONLINE_MAN_TRANS', label: 'Online' },
  online: { id: 'ONLINE_MASTERCARD', label: 'Online' },
  payPal: { id: 'ONLINE_PAYPAL', label: 'Paypal' },
  globalPayments: { id: 'ONLINE_GP', label: 'Online' },
  globalPaymentsWebpay: { id: 'ONLINE_GP_WP', label: 'Online' },
  offline: { id: 'OFFLINE', label: 'Offline' },
  exempt: { id: 'EXEMPT', label: 'Exempt' },
  directTransfer: { id: 'DIRECT_TRANSFER', label: 'Direct transfer' }
})

export const CODE_LISTS = enumize({
  GENDERS: { id: 'CL_GENDERS', label: 'genders' },
  EMPLOYMENT_STATUSES: {
    id: 'CL_EMPLOYMENT_STATUSES',
    label: 'employmentStatuses'
  },
  NATIONALITIES: { id: 'CL_NATIONALITIES', label: 'nationalities' },
  TITLES: { id: 'CL_TITLES', label: 'titles' },
  PHONE_TYPES: { id: 'CL_PHONE_TYPES', label: 'phoneTypes' },
  CONSENT_DELIVERY_TYPES: {
    id: 'CL_CONSENT_DELIVERY_TYPES',
    label: 'consentDeliveryTypes'
  },
  PARTICIPANT_PAYMENT_STATES: {
    id: 'CL_PARTICIPANT_PAYMENT_STATES',
    label: 'participantPaymentStates'
  },
  USER_REGISTRATION_ASSESSMENT_STATES: {
    id: 'CL_USER_REGISTRATION_ASSESSMENT_STATES',
    label: 'userRegistrationAssessmentStates'
  },
  AJ_CATEGORIES_TYPES: {
    id: 'CL_AJ_EVENT_CATEGORIES',
    label: 'ajEventCategories'
  },
  MODE_OF_TRANSPORT_TYPES: {
    id: 'CL_MODE_OF_TRANSPORT_TYPES',
    label: 'modeOfTransportTypeList'
  },
  PROJECT_LOCATION_TYPES: {
    id: 'CL_PROJECT_LOCATION_TYPES',
    label: 'projectLocationTypes'
  },
  ORGANIZATION_TYPES: {
    id: 'CL_ORGANIZATION_TYPES',
    label: 'organizationTypes'
  },
  ORGANIZATION_CONTACT_ROLE_TYPES: {
    id: 'CL_ORGANIZATION_CONTACT_ROLE_TYPES',
    label: 'organizationContactRoleTypes'
  },
  CL_OC_REASON_DELETION_TYPES: {
    id: 'CL_OC_REASON_DELETION_TYPES',
    label: 'organizationContactReasonsOfDeletionTypes'
  },
  CL_PART_REASON_DELETION_TYPES: {
    id: 'CL_PART_REASON_DELETION_TYPES',
    label: 'participantReasonsOfDeletionTypes'
  },
  ACTIVITY_SECTIONS: { id: 'CL_ACTIVITY_SECTIONS', label: 'activitySections' },
  AWARD_FILE_CATEGORIES: { id: 'CL_AWARD_FILE_CATEGORIES', label: 'awardFileCategories' },
  PERSON_STATES: { id: 'CL_PERSON_STATES', label: 'personStates' },
  ACTIVITY_REVISE_REASONS: { id: 'CL_ACTIVITY_REVISE_REASON_TYPES', label: 'activityReviseReasons' },
  CL_ANNOUNCEMENT_SEVERITY_STATES: { id: 'CL_ANNOUNCEMENT_SEVERITY_STATES', label: 'announcementSeverityStates' },
  ASSESSOR_DELETE_REGISTRATION_REASONS: {
    id: 'CL_ASS_REG_REASON_DELETION_TYPES',
    label: 'assessorReasonsOfDeletionTypes'
  },
  ORGANIZATION_STATES: {
    id: 'CL_ORGANIZATION_STATES',
    label: 'organizationStates'
  },
  AWARD_LEVELS_TYPES: { id: 'CL_AWARD_LEVEL_TYPES', label: 'awardLevelTypes' },
  AWARD_STATES: { id: 'CL_AWARD_STATES', label: 'awardStates' },
  INVOICE_CURRENCIES: {
    id: 'CL_INVOICE_CURRENCIES',
    label: 'invoiceCurrencies'
  },
  VAT_TREATMENTS: { id: 'CL_VAT_TREATMENTS', label: 'vatTreatments' },
  ORGANIZATION_MODES: {
    id: 'CL_ORGANIZATION_MODES',
    label: 'organizationModes'
  },
  AWARD_MODES: {
    id: 'CL_AWARD_MODES',
    label: 'awardModes'
  },
  MESSAGE_TYPES: { id: 'CL_MESSAGE_TYPES', label: 'messageTypes' },
  MESSAGE_STATES: { id: 'CL_MESSAGE_STATES', label: 'messageStates' },
  LABEL_TYPES: { id: 'CL_LABEL_CATEGORY_TYPES', label: 'labelTypes' }

})

export const ACTIVITY_SECTIONS = enumize({
  physical: {
    id: 'PHYSICAL_RECREATION',
    link: 'physical',
    index: 1,
    intlKey: 'award.physical_recreation',
    label: 'Physical recreation'
  },
  skills: {
    id: 'SKILL',
    link: 'skills',
    index: 2,
    intlKey: 'award.skills',
    label: 'Skills'
  },
  service: {
    id: 'SERVICE',
    link: 'service',
    index: 3,
    intlKey: 'award.service',
    label: 'Service'
  },
  rp: {
    id: 'RESIDENTIAL_PROJECT',
    link: 'rp',
    index: 4,
    intlKey: 'award.rp',
    label: 'Residential project'
  },
  aj: {
    id: 'ADVENTUROUS_JOURNEY',
    link: 'aj',
    index: 5,
    intlKey: 'award.aj',
    label: 'Adventurous journey'
  }
})

export const ACTIVITY_SECTIONS_AJ = enumize({
  practice: {
    id: 'PRACTICE',
    index: 1,
    intlKey: 'aj.practice_journey',
    label: 'Practice journey'
  },
  qualify: {
    id: 'QUALIFICATION',
    index: 2,
    intlKey: 'aj.qualifying_journey',
    label: 'Qualifying journey'
  }
})

export const ACTIVITY_CATEGORIES = enumize({
  other: { id: 'OTHER' }
})

export const PROGRESS_STATES = enumize({
  awardSetup: { id: 'SETUP' },
  awardInProgress: { id: 'IN_PROGRESS' },
  awardLeaderSignoff: { id: 'LEADER_SIGNOFF' },
  awardOfficeSignoff: { id: 'OFFICE_SIGNOFF' },
  awardLevelComplete: { id: 'COMPLETE' },
  awardAwardComplete: { id: 'COMPLETE' },
  awardCeremony: { id: 'CEREMONY' },
  awardRegAssessment: { id: 'REG_ASSIGNMENT' },
  awardRegApproval: { id: 'REG_APPROVAL' },
  awardRegNotApproved: { id: 'REG_NOT_APPROVED' },
  awardInactive: { id: 'INACTIVE' },
  ajActive: { id: 'ACTIVE' },
  alApproved: { id: 'APPROVED' },
  participantApproved: { id: 'APPROVED' },
  activitySetup: { id: 'SETUP' },
  activityApproval: { id: 'APPROVAL' },
  activityInProgress: { id: 'IN_PROGRESS' },
  activityAssessment: { id: 'ASSESSMENT' },
  activityLeaderSignoff: { id: 'LEADER_SIGNOFF' },
  activityComplete: { id: 'COMPLETE' },
  activityOfficeSignoff: { id: 'OFFICE_SIGNOFF' },
  activityCeremony: { id: 'CEREMONY' },
  activityInactive: { id: 'INACTIVE' },
  activityDeleted: { id: 'DELETED' },
  approvementState: { id: 'APPROVED' }
})

export const AJ_PROGRESS_STATES = enumize({
  ajSetup: { id: 'SETUP' },
  ajApproval: { id: 'APPROVAL' },
  ajInProgress: { id: 'IN_PROGRESS' },
  ajAssessorApproval: { id: 'ASSESSMENT' },
  ajLeaderSignoff: { id: 'LEADER_SIGNOFF' },
  ajOfficeSignoff: { id: 'OFFICE_SIGNOFF' },
  ajCeremonySignoff: { id: 'CEREMONY' },
  ajComplete: { id: 'COMPLETE' },
  ajInactive: { id: 'INACTIVE' }
})

export const RP_PROGRESS_STATES = enumize({
  rpSetup: { id: 'SETUP' },
  rpApproval: { id: 'APPROVAL' },
  rpInProgress: { id: 'IN_PROGRESS' },
  rpAssessorApproval: { id: 'ASSESSMENT' },
  rpLeaderSignoff: { id: 'LEADER_SIGNOFF' },
  rpOfficeSignoff: { id: 'OFFICE_SIGNOFF' },
  rpCeremonySignoff: { id: 'CEREMONY' },
  rpComplete: { id: 'COMPLETE' },
  rpInactive: { id: 'INACTIVE' }
})

export const AJ_TRAINING_PROGRESS_STATES = enumize({
  ajTrainingInProgress: { id: 'IN_PROGRESS' },
  ajTrainingLeaderSignoff: { id: 'LEADER_SIGNOFF' },
  ajTrainingOfficeSignoff: { id: 'OFFICE_SIGNOFF' },
  ajTrainingCeremony: { id: 'CEREMONY' },
  ajTrainingComplete: { id: 'COMPLETE' }

})

export const AJ_MIN_DATES = enumize({
  bronze: { days: 2, nights: 1 },
  silver: { days: 3, nights: 2 },
  gold: { days: 4, nights: 3 }
})

export const ACTIONS = enumize({
  ACT_APPROVAL: { id: 'ACT_APPROVAL' },
  ACT_ASSESSMENT_REQ: { id: 'ACT_ASSESSMENT_REQ' },
  AW_LEADER_ASSESSMENT: { id: 'AW_LEADER_ASSESSMENT' }
})

export const CONSENT_DELIVERY_TYPES = enumize({
  electronically: { id: 'ELECTRONICALLY' },
  paper: { id: 'PAPER' },
  notRequired: { id: 'NOT_REQUIRED' }
})

export const PERSON_STATES = enumize({
  active: { id: 'ACTIVE' },
  inactive: { id: 'INACTIVE' },
  activating: { id: 'ACTIVATION_IN_PROGRESS' }
})

export const PARTICIPANTS_BULK = enumize({
  inactive: { id: 'INACTIVE' },
  resendParentalConsent: { id: 'RESEND_PARENTAL_CONSENT' },
  toCeremony: { id: 'TO_CEREMONY' },
  nextLevelInvitation: { id: 'NEXT_LEVEL_INVITATION' },
  collectEmails: { id: 'COLLECT_EMAILS' },
  sendMessage: { id: 'SEND_MESSAGE' },
  transferParticipants: { id: 'TRANSFER_PARTICIPANTS' },
  assignLabels: { id: 'ASSIGN_LABELS' },
  unassignLabels: { id: 'UNASSIGN_LABELS' },
  resendConfirmationEmail: { id: 'RESEND_CONFIRMATION_EMAIL' },
  changeParentalConsent: { id: 'CHANGE_PARENTAL_CONSENT' },
  assignAwardLabels: { id: 'ASSIGN_AWARD_LABELS' },
  unassignAwardLabels: { id: 'UNASSIGN_AWARD_LABELS' },
  offlineToComplete: { id: 'OFFLINE_TO_COMPLETE' }
})

export const LEADERS_BULK = enumize({
  assignLabels: { id: 'ASSIGN_CONTACT_LABELS' },
  unassignLabels: { id: 'UNASSIGN_CONTACT_LABELS' }
})

export const ORGANIZATIONS_BULK = enumize({
  assignLabels: { id: 'ASSIGN_ORGANIZATION_LABELS' },
  unassignLabels: { id: 'UNASSIGN_ORGANIZATION_LABELS' }
})

export const APPROVAL_BULK = enumize({
  registration: { id: 'REGISTRATION_APPROVAL' },
  resendParentalConsent: { id: 'RESEND_PARENTAL_CONSENT' }
})

export const INVITED_PARTICIPANTS_BULK = enumize({
  resendInvitationEmail: { id: 'RESEND_INVITATION_EMAIL' },
  delete: { id: 'DELETE' }
})

export const AWARD_MODES = enumize({
  offline: { id: 'OFFLINE' },
  online: { id: 'ONLINE' }
})

export const ORGANIZATION_MODES = enumize({
  offline: { intlKey: 'label.awardMode.offline', id: 'OFFLINE' },
  online: { intlKey: 'label.awardMode.online', id: 'ONLINE' },
  hybrid: { intlKey: 'label.awardMode.hybrid', id: 'HYBRID' }
})

export const ORGANIZATION_HIERARCHY = enumize({
  IAF: { id: 1, value: 'IAF' },
  RO: { id: 5, value: 'RO' },
  NAO: { id: 2, value: 'NAO' },
  IAC: { id: 4, value: 'IAC' },
  AU: { id: 3, value: 'AU' },
  OA: { id: 6, value: 'OA' },
  SOA: { id: 7, value: 'SOA' },
  IC: { id: 8, value: 'IC' },
  GOP: { id: 9, value: 'GOP' },
  SGOP: { id: 10, value: 'SGOP' },
  ALL: { id: 0, u: 'ALL' }
})

export const REMOVE_CONTACT_TYPES = enumize({
  ORGANIZATION_CONTACT: { value: 'ORGANIZATION_CONTACT' },
  AWARD_LEADER: { value: 'AWARD_LEADER' },
  PARTICIPANT: { value: 'PARTICIPANT' },
  ASSESSOR: { value: 'ASSESSOR' },
  PARTICIPANT_REGISTRATION: { value: 'PARTICIPANT_REGISTRATION' },
  AWARD_UNIT: { value: 'AWARD_UNIT' }
})

export const LABEL_CATEGORY_TYPES = enumize({
  PERSON: { id: 'PERSON' },
  ORGANIZATION: { id: 'ORGANIZATION' },
  CONTACT: { id: 'CONTACT' },
  AWARD: { id: 'AWARD' }
})

export const SUPPORTED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/pdf',
  'video/mp4'
]

export const SUPPORTED_IMAGE_FILE_TYPES = [
  'image/jpeg',
  'image/png'
]

export const SUPPORTED_IMAGES_EXTENSIONS = ['jpeg', 'jpg', 'png']

export const HEADER_COLORS = {
  blue: { id: 'BLUE' },
  green: { id: 'GREEN' }
}

export const SEARCH_ENTITIES = {
  PARTICIPANT: { id: 'PARTICIPANT' },
  AL_REGISTRATION: { id: 'AL_REGISTRATION' },
  AU_REGISTRATION: { id: 'AU_REGISTRATION' },
  ASSESSOR_REGISTRATION: { id: 'ASSESSOR_REGISTRATION' },
  ORG_CONTACT: { id: 'ORG_CONTACT' },
  ORGANIZATION: { id: 'ORGANIZATION' }
}

export const ERROR_CODES = {
  unauthorized: { id: 'UNAUTHORIZED' },
  authCodeExpired: { id: 'AUTH_CODE_EXPIRATED' },
  viewerRejected: { id: 'VIEWER_REJECTED' }
}

export const EMAIL_REVISION_ACTION_REQUESTS = {
  ACTIVITY_ASSESSMENT_REQUEST: { id: 'ACTIVITY_ASSESSMENT_REQUEST' },
  RP_ASSESSMENT_REQUEST: { id: 'RP_ASSESSMENT_REQUEST' },
  AJ_PARTICIPANT_ASSESSMENT_REQUEST: { id: 'AJ_PARTICIPANT_ASSESSMENT_REQUEST' }
}


export const TOKEN_STATES = {
  revoked: { id: 'TOKEN_REVOKED' },
  expired: { id: 'TOKEN_EXP' },
  unauthorized: { id: 'UNAUTHORIZED' }
}

export const HTTP_STATUS_CODES = {
  SERVICE_UNAVAILABLE: 503
}

export const ACTIVITY_STATE_CATEGORIES = enumize({
  activity: { id: 'ACTIVITY' },
  residentialProject: { id: 'RP' },
  award: { id: 'AWARD' }
})

export const BADGE_LEVELS = enumize({
  apprentice: { id: 'APPRENTICE' },
  hero: { id: 'HERO' },
  master: { id: 'MASTER' }
})


export const EMAIL_TYPES = enumize({
  awardCompletionEmail: { id: 'AWARD_EMAIL_P' },
  awardCompletionEmailSurvey: { id: 'SURVEY_EMAIL_P' },
  AwardLeaderRejectionEmail: { id: 'AWARD_EMAIL_AL' },
  assessorWelcomeEmail: { id: 'WELCOME_EMAIL_A' },
  awardRegistrationApprovalEmail: { id: 'E_REG_APRVL' },
  awardRegistrationApprovalEmailSurvey: { id: 'E_REG_APRVL_SRV' },
  activityAssessmentRequestEmail: { id: 'ASSESSMENT_REQ_E' },
  ajAssessmentRequestEmail: { id: 'ASSESSMENT_AJ_REQ_E' },
  rpAssessmentRequestEmail: { id: 'ASSESSMENT_RP_REQ_E' },
  awardLeaderConfirmationSignoffEmail: { id: 'AL_CONFIRM_SIGNOFF_E' },
  participantNextLevelInvitationEmail: { id: 'P_NEXT_LVL_INVITATION_E' },
  parentalConsentEmail: { id: 'PARENTAL_CONSENT_E' },
  participantArchivingEmail: { id: 'ARCH_PAR_EMAIL' },
  participantRegistrationDeletionEmail: { id: 'PAR_REG_DEL_E' },
  awardLeaderRegistrationConfirmationEmail: { id: 'AL_REG_CONFIRM_E' },
  awardLeaderRegistrationConfirmationDeclinedEmail: { id: 'AL_REG_NOT_CONFIRM_E' },
  createRoleInvitationEmail: { id: 'CREATE_ROLE_INV_E' },
  parentalConsentInfoEmail: { id: 'PARENTAL_CONSENT_I_E' },
  paymentReceiptEmail: { id: 'PAYMENT_RECEIPT_E' },
  resetPasswordEmail: { id: 'PSW_RST_E' },
  loginChangeRequestEmail: { id: 'LOGIN_CHNG_REQ_E' },
  addressChangeNewEmail: { id: 'ADDRESS_CHNG_NEW_E' },
  addressChangePreviousEmail: { id: 'ADDRESS_CHNG_PREV_E' }
})

export const AWARD_FILE_CATEGORY_TYPES = enumize({
  activity: { id: 'ACTIVITY' },
  adventureJourney: { id: 'ADVENTURE_JOURNEY' },
  residentialProject: { id: 'RESIDENTIAL_PROJECT' },
  other: { id: 'OTHER' },
  parentalConsent: { id: 'PARENTAL_CONSENT' }

})

export const LABELS_TYPES = enumize({
  contact: { id: 'CONTACT' },
  person: { id: 'PERSON' },
  organization: { id: 'ORGANIZATION' },
  award: { id: 'AWARD' }
})

export const POLICIES_TYPES = enumize({
  link: { id: 'LINK' },
  text: { id: 'TEXT' },
  file: { id: 'FILE' }

})

export const ASSESSOR_WWC_STATE_TYPES = enumize({
  pending: { id: 'PENDING' },
  approved: { id: 'APPROVED' },
  revised: { id: 'REVISED' },
  exempted: { id: 'EXEMPTED' },
  expired: { id: 'EXPIRED' }
})

export const ASSESSOR_ACTIVITY_REGISTRATION_STATES = enumize({
  created: { id: 'CREATED' },
  pending: { id: 'PENDING' },
  approval: { id: 'APPROVAL' },
  revised: { id: 'REVISED' },
  completed: { id: 'COMPLETED' }
})

export const ASSESSOR_REGISTRATION_STATES = enumize({
  approval: { id: 'APPROVAL' },
  registered: { id: 'REGISTERED' },
  expired: { id: 'REG_CHILD_P_EXPIRED' },
  revised: { id: 'revised' }
})


export const ASSESSOR_PARTICIPANTS_FILTER_TYPE = enumize({
  activity: { id: 'ACTIVITY' },
  aj: { id: 'AJ' },
  rp: { id: 'RP' }
})

export const AWARD_TYPES = enumize({
  regular: { id: 'REGULAR' },
  simplified: { id: 'SIMPLIFIED' }
})

export const TRANSLATION_PROJECTS = enumize({
  backend: { id: 'BE', intlKey: 'label.backend', defaultMessage: 'Backend (emails, dropdowns, values)'},
  backoffice: { id: 'BO', intlKey: 'label.backoffice', defaultMessage: 'Backoffice (Award Staff web static labels)'},
  frontoffice: { id: 'FO', intlKey: 'label.frontoffice', defaultMessage: 'Frontoffice (Participant web static labels)'},
  userEngagementBackend: { id: 'UEBE', intlKey: 'label.ue_be', defaultMessage: 'User Engagement Backend (dropdowns, values, etc.)'},
  userEngagementFrontend: { id: 'UEFE', intlKey: 'label.ue_fe', defaultMessage: 'User Engagement Frontend (Participant web static labels)'},
  assessorWebBackend: { id: 'AWBE', intlKey: 'label.aw_be', defaultMessage: 'Assessor Web Backend (dropdowns, values, etc.)'},
  assessorWebFrontend: { id: 'AWFE', intlKey: 'label.aw_fe', defaultMessage: 'Assessor Web Frontend (Assessor web static labels)'},
  customisableEmails: { id: 'CEBE', intlKey: 'label.ce_be', defaultMessage: 'Customisable Emails (emails translations)'},
  documents: { id: 'DOC', intlKey: 'projects.doc', defaultMessage: 'Documents (Translations for the labels used in the documents and the reports)'}
})

